import React, { useState, useEffect, useRef } from 'react'
import { Outlet,redirect, Navigate } from 'react-router-dom'
import Navigation from '../components/Navigation'
import Navbar from '../components/Navigation/Navbar'
import Footer from '../components/Footer'
import { session, clearSession, setSession } from '../utils/AuthSession'
import { ThemeProvider } from '../context/ThemeContext'

function MainLayout() {
    const [authSession, setAuthSession] = useState(session())

    useEffect(()=>{
        if(authSession){

        }
    },[])

    if(authSession){
        return (
            <ThemeProvider>
                <div className='flex flex-col h-screen justify-between'>
                    <Navbar />
                    <Outlet />
                    <Navigation />
                </div>
            </ThemeProvider>

        )
    }else{
        return (
            <Navigate to="/auth/login" replace={true} />
        )
    }
    
}

export default MainLayout